import { render, staticRenderFns } from "./DeleteOrderReasonManagement.vue?vue&type=template&id=657f2078&scoped=true"
import script from "./DeleteOrderReasonManagement.vue?vue&type=script&lang=js"
export * from "./DeleteOrderReasonManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657f2078",
  null
  
)

export default component.exports